/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from "react"
import {useTheme} from "@mui/material/styles"
import List from "@mui/material/List"
import Divider from "@mui/material/Divider"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import useMediaQuery from "@mui/material/useMediaQuery"
import {navigate} from "gatsby"

import {ToggleFunctionType} from "../layouts/Layout"
import BaseDrawer, {standardWidthFactor} from "./BaseDrawer"
import {logout} from "../services/auth"

interface MenuItemType {
  text: string
  icon: any
  divider?: boolean
  page?: string
  key?: string
}

interface MenuDrawerProps {
  anchor: "top" | "bottom" | "left" | "right"
  open: boolean
  toggleDrawer: ToggleFunctionType
  items: MenuItemType[]
  closeOnMenuItemClick?: boolean
}

const MenuDrawer: React.FC<MenuDrawerProps> = ({
                                                 anchor,
                                                 open,
                                                 toggleDrawer,
                                                 items,
                                                 closeOnMenuItemClick = true
                                               }) => {
  const theme = useTheme()
  const notMobile = useMediaQuery(theme.breakpoints.up("sm"))
  // force uniqueness of items
  const listItems = Array.from(new Map(items.map((item) => [item.text, item])).values())
    .map(({text, icon, divider, page}, index) =>
      <React.Fragment key={index}>
        {divider && <Divider/>}
        <ListItem
          key={index}
          onClick={(e) => {
            e.preventDefault()
            if (!notMobile || closeOnMenuItemClick) toggleDrawer(open)()
            if (text.toLowerCase() === "logout") {
              logout(() => navigate("/login"))
            } else {
              navigate(`/${(page || (text !== "Home" ? text : "")).toLowerCase().replace(" ", "_")}`)
            }
          }}
        >
          <ListItemButton dense={true} disableGutters={true}>
            <ListItemIcon>
              {icon}
            </ListItemIcon>
            <ListItemText primary={text}/>
          </ListItemButton>
        </ListItem>
      </React.Fragment>
    )

  return (
    <BaseDrawer open={open} toggleDrawer={toggleDrawer} anchor={anchor}>
      <List dense={true} disablePadding={true} sx={{zIndex: (theme) => theme.zIndex.drawer + 2}}>
        {listItems}
      </List>
    </BaseDrawer>
  )
}

export default MenuDrawer
